import { Box, Card, Chip, Dialog, Button as MUIButton, Tooltip, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { ReactElement, useState, useEffect, useRef } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  useListContext,
  useDataProvider,
  ListBase,
  TextInput,
  SelectInput,
  Button,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import AddressField from 'src/pages/admin/components/AddressField';
import CreateXStock from './Create';
import { chains } from 'src/assets/data';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import AuditLogDialog from 'src/pages/admin/components/AuditLog/AuditLogDialog';
import { Iconify } from 'src/components/iconify/iconify';

const ListFilter = (props: any) => {
  const { filterValues } = useListController();

  return (
    <Filter {...(props || {})}>
      <FilterGroup alwaysOn spacing={0} p={0}>
        <FilterGroup>
          <TextInput source="address" label="module.tokenMetadata.address" />
          {/* <SelectInput
            source="chainId"
            helperText={<span style={{ color: 'red' }}></span>}
            choices={chains}
          /> */}
        </FilterGroup>
      </FilterGroup>
    </Filter>
  );
};

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();
  const [auditLogOpen, setAuditLogOpen] = useState(false);
  const [auditTitle, setAuditTitle] = useState('Audit Logs');
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  return (
    <PermissionGuard resource="x-stocks" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.token-X-Stock')}
          links={[
            { name: translate('resource.token-X-Stock'), href: `/${Resources.tokenXstock}` },
            { name: translate('resource.list') },
          ]}
          action={
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretch', sm: 'center' }}
              spacing={2}
              mb={1}
            >
              <PermissionGuard resource="x-stocks" action="create" fallback={<></>}>
                <CreateButton
                  variant="contained"
                  size="medium"
                  onClick={(e) => {
                    e.preventDefault();
                    setPopup(<CreateXStock onClose={() => setPopup(undefined)} />);
                  }}
                />
              </PermissionGuard>
              <PermissionGuard resource="audit-logs" action="read" fallback={<></>}>
                <Button
                  variant="contained"
                  size="medium"
                  color="secondary"
                  onClick={() => {
                    setSelectedRecord({});
                    setAuditTitle(`${translate('resource.auditLogs')} - ${translate('resource.token-X-Stock')}`);
                    setAuditLogOpen(true);
                  }}
                  label={translate('resource.auditLogs')}
                >
                  <Iconify icon="ph:note" />
                </Button>
              </PermissionGuard>
            </Stack>
          }
        />
        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            filters={<ListFilter />}
            perPage={10}
            exporter={false}
          >
            {/* <PollingDatagrid /> */}
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="x-stocks" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <FunctionField
                  label="module.tokenMetadata.address"
                  render={(record: any) => <AddressField address={record.address} />}
                  sortable={false}
                />{' '}
                <TextField source="symbol" label="module.tokenMetadata.symbol" sortable={false} />
                <TextField source="name" label="module.tokenMetadata.name" sortable={false} />
                <SelectField
                  source="chainId"
                  choices={chains}
                  label="module.tokenMetadata.chain"
                  sortable={false}
                />
                <FunctionField
                  label="module.tokenOnchainInfo.status"
                  render={(record) => (
                    <Chip
                      label={
                        record.status
                          ? translate('module.tokenOnchainInfo.success')
                          : translate('module.tokenOnchainInfo.inProgress')
                      }
                      color={record.status ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <FunctionField
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      <PermissionGuard resource="x-stocks" action="delete" fallback={<></>}>
                        <DeleteButton mutationMode="pessimistic" />
                      </PermissionGuard>
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>

        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
        <AuditLogDialog
          open={auditLogOpen}
          onClose={() => setAuditLogOpen(false)}
          recordId={selectedRecord?.id}
          resource={Resources.tokenXstock}
          title={auditTitle}
        />
      </DashboardContent>
    </PermissionGuard>
  );
};

// const PollingDatagrid = () => {
//   const { refetch } = useListContext();
//   const intervalRef = useRef<NodeJS.Timeout | null>(null);

//   useEffect(() => {
//     intervalRef.current = setInterval(() => {
//       refetch?.();
//     }, 5000);

//     return () => {
//       if (intervalRef.current) clearInterval(intervalRef.current);
//     };
//   }, [refetch]);

//   return null;
// };

export default View;
